import { render, staticRenderFns } from "./DateQuestion.vue?vue&type=template&id=da981c2c&scoped=true&"
import script from "./DateQuestion.vue?vue&type=script&lang=js&"
export * from "./DateQuestion.vue?vue&type=script&lang=js&"
import style0 from "./DateQuestion.vue?vue&type=style&index=0&id=da981c2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da981c2c",
  null
  
)

export default component.exports